import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.DEV,
    fallbackLng: "de",
    supportedLngs: ["en", "de", "es"],
    cleanCode: true,

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      excludeCacheFor: ["cimode"], // exclude certain languages from being cached
      convertDetectedLanguage: (lng: string) => {
        // Ensure we only use supported languages
        return ["en", "de", "es"].includes(lng) ? lng : "de";
      }
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json"
    },

    // Set language attribute on html element
    react: {
      useSuspense: false
    },

    ns: ["common", "auth", "talent", "applications", "partner", "config"],
    defaultNS: "common"
  });

// Debug language detection
if (import.meta.env.DEV) {
  console.log("🌍 Language Detection Debug:");
  console.log("- Detected language:", i18n.language);
  console.log("- Stored in localStorage:", localStorage.getItem("i18nextLng"));
  console.log("- Navigator language:", navigator.language);
  console.log("- HTML lang attribute:", document.documentElement.lang);
}

export default i18n;
